import { useState, useEffect, useRef } from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { useNavigate } from 'react-router-dom'
import { ListingCampaignForm } from '../components/ListingCampaignForm'
import { Loading } from '../components/ui/Loading'
import { CampaignAPI } from '../api/CampaignAPI'
import { ProgressError } from '../components/ui/ProgressError'
import { TemplateLibrary } from '../components/TemplateLibrary'
import { ListingAssetUploader } from '../components/ListingAssetUploader'

const MAX_TEMPLATES = 5
export const ListingCampaign = () => {
    const [loadState, setLoadState] = useState({
        loading: false,
        msg: null,
    })
    const [isError, setIsError] = useState({ state: false })
    const [step, setStep] = useState(0)
    const [templates, setTemplates] = useState(null)
    const listing = useRef(null)
    const campaignId = useRef(null)
    const navigate = useNavigate()

    const createCampaign = (templates) => {
        CampaignAPI.createListingCampaign(listing.current.id)
            .then((response) => {
                campaignId.current = response.data.id
                setStep(2)
                setTemplates(templates)
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    const saveListing = (title, productId) => {
        setLoadState({
            loading: true,
            msg: 'Saving listing data...',
        })
        CampaignAPI.createListing(title, productId)
            .then((response) => {
                listing.current = response.data
                setLoadState({ loading: false })
                setStep(1)
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    const extractProduct = ({ title, url }) => {
        setLoadState({
            loading: true,
            msg: 'Scanning url...',
        })
        CampaignAPI.extractProduct(url)
            .then((response) => {
                if (response.data.status === 'ok') {
                    saveListing(title, response.data.id)
                } else {
                    setIsError({ state: true, msg: response.data.reason })
                }
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    let body = null
    if (isError.state == true) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <ProgressError
                    msg={isError.msg}
                    path="/merchant/calendar_v2/"
                />
            </Box>
        )
    } else if (loadState.loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Loading message={loadState.msg} />
            </Box>
        )
    }

    if (step == 0) {
        body = (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography level="h2" color="neutral">
                    Create Listing Campaign
                </Typography>
                <ListingCampaignForm onSubmit={extractProduct} />
            </Box>
        )
    } else if (step == 1) {
        body = (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <TemplateLibrary
                    onSubmit={createCampaign}
                    maxItems={MAX_TEMPLATES}
                    templateType="product"
                />
            </Box>
        )
    } else if (step == 2) {
        body = (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <ListingAssetUploader
                    listing={listing.current.product}
                    campaignId={campaignId.current}
                    templates={templates}
                    onStatusChanged={() =>
                        navigate(
                            `/merchant/view_campaign_v2/${campaignId.current}`
                        )
                    }
                />
            </Box>
        )
    }

    return body
}
